<template>
<div class="contents">
  <admin-customer-profile-edit adminType="staff" :id="id" />
</div>
</template>

<script>
import AdminCustomerProfileEdit from '../Admin/AdminCustomerProfileEdit.vue'

export default {
  name: 'staff-customer-profile-edit',
  components: {
    AdminCustomerProfileEdit
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  }
}
</script>
